module.exports = __webpack_public_path__ + "static/media/flipHorizontal.e5fdff38.svg";